import React, { Component } from 'react';
import {
  Card,
  Button,
  Typography,
  Select,
  Radio,
  Space,
  Switch,
  Popconfirm,
  Divider,
} from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateSkill, channelAdminConfig } from '../skills_action';
import queryString from 'query-string';
import { getBotUsers } from '../skills_action';
import MemberSelect from 'components/common/memberSelect';
const { Text } = Typography;
const { Option } = Select;

class GlobalGuestTokenRestriction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      botEditMode: false,
      saveLoading: false,
      actionDisabled: false,
      globalGuestTokenRestriction: {
        ...this.intialGlobalGuestTokenRestriction,
      },
    };
  }

  intialGlobalGuestTokenRestriction = {
    restrictionDisabled: true,
    restriction_type: 'block',
    selectedUsers: [],
    botRestrictionDisabled: true,
    botRestriction_type: 'block',
    botUsers: [],
  };

  componentDidMount() {
    this.setStateValues();

    this.props.getBotUsers(this.props.match.params.wId);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.sub_skill !== prevProps.match.params.sub_skill
    ) {
      this.setStateValues();
    }
  }

  setStateValues = () => {
    const {
      currentSkill,
      forChannelGuestTokenRestriction,
      currentChannelConfigs,
    } = this.props;
    const skill =
      currentSkill && currentSkill.skill_metadata
        ? currentSkill.skill_metadata
        : currentSkill;

    if (forChannelGuestTokenRestriction) {
      if (
        currentChannelConfigs &&
        currentChannelConfigs.channelGuestTokenRestriction
      )
        this.setState({
          globalGuestTokenRestriction:
            currentChannelConfigs.channelGuestTokenRestriction,
        });
    } else if (this.props.match.params.sub_skill === 'jira_software') {
      if (
        skill &&
        skill.globalProjectGuestTokenRestriction &&
        (skill.globalProjectGuestTokenRestriction.restriction_type ||
          skill.globalProjectGuestTokenRestriction.botRestriction_type)
      )
        this.setState({
          globalGuestTokenRestriction: {
            ...skill.globalProjectGuestTokenRestriction,
          },
        });
    } else {
      if (
        skill &&
        skill.globalGuestTokenRestriction &&
        skill.globalGuestTokenRestriction.restriction_type &&
        skill.globalGuestTokenRestriction.botRestriction_type
      )
        this.setState({
          globalGuestTokenRestriction: { ...skill.globalGuestTokenRestriction },
        });
    }
    this.setState({ editMode: false, botEditMode: false });
  };

  handleChange = ({ type, value, option }) => {
    const { globalGuestTokenRestriction } = this.state;
    const temp = { ...globalGuestTokenRestriction };
    if (type === 'select') temp.selectedUsers = option.map((o) => o.key);
    else if (type === 'bot_select') {
      temp.botUsers = option.map((o) => o.key);
    } else if (type === 'bot_radio') {
      temp.botRestriction_type = value;
    } else if (type === 'radio') temp.restriction_type = value;
    this.setState({ globalGuestTokenRestriction: temp });
  };

  handleSwitch = (checked, isBot) => {
    const { globalGuestTokenRestriction } = this.state;
    let temp = { ...globalGuestTokenRestriction };
    if (isBot) {
      temp.botRestrictionDisabled = !checked;
    } else {
      temp.restrictionDisabled = !checked;
    }

    this.setState({ globalGuestTokenRestriction: temp }, () =>
      this.handleSave('switch')
    );
  };

  handleDelete = (type) => {
    const { forChannelGuestTokenRestriction } = this.props;
    if (forChannelGuestTokenRestriction) {
      const queryParams = queryString.parse(this.props.location.search);
      this.props
        .channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          queryParams.channel_id,
          {
            channelGuestTokenRestriction: {
              ...this.intialGlobalGuestTokenRestriction,
            },
          },
          this.props.isGridSharedChannel
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({
              editMode: false,
              globalGuestTokenRestriction: {
                ...this.intialGlobalGuestTokenRestriction,
              },
            });
          }
        });
    } else {
      let defaultValues = {};
      if (type == 'bot') {
        defaultValues = {
          botRestrictionDisabled: true,
          botRestriction_type: 'block',

          botUsers: [],
        };
      } else {
        defaultValues = {
          restrictionDisabled: true,
          restriction_type: 'block',

          selectedUsers: [],
        };
      }

      let updateVal = {
        ...this.state.globalGuestTokenRestriction,
        ...defaultValues,
      };

      let data = {};
      if (this.props.match.params.sub_skill === 'jira_software') {
        data = { globalProjectGuestTokenRestriction: updateVal };
      } else {
        data = { globalGuestTokenRestriction: updateVal };
      }

      this.props
        .updateSkill(
          this.props.match.params.skill_id,
          this.props.match.params.wId,
          data
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({
              editMode: false,
              globalGuestTokenRestriction: { ...updateVal },
            });
          }
        });
    }
  };

  handleSave = () => {
    const { globalGuestTokenRestriction } = this.state;
    const { forChannelGuestTokenRestriction } = this.props;
    this.setState({ saveLoading: true });
    let data = {};
    if (forChannelGuestTokenRestriction)
      data = { channelGuestTokenRestriction: globalGuestTokenRestriction };
    else if (this.props.match.params.sub_skill === 'jira_software')
      data = {
        globalProjectGuestTokenRestriction: globalGuestTokenRestriction,
      };
    else data = { globalGuestTokenRestriction };

    if (forChannelGuestTokenRestriction) {
      const queryParams = queryString.parse(this.props.location.search);
      this.props
        .channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          queryParams.channel_id,
          data,
          this.props.isGridSharedChannel
        )
        .then((res) => {
          if (res.data && res.data.success)
            this.setState({
              editMode: false,
              saveLoading: false,
              botEditMode: false,
            });
        });
    } else {
      this.props
        .updateSkill(
          this.props.match.params.skill_id,
          this.props.match.params.wId,
          data
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({
              editMode: false,
              saveLoading: false,
              botEditMode: false,
            });
          }
        });
    }
  };

  handleCancel = () => {
    const { currentSkill } = this.props;
    let skill = currentSkill;
    if (this.props.match.params.sub_skill === 'jira_software') {
      if (
        skill &&
        skill.globalProjectGuestTokenRestriction &&
        (skill.globalProjectGuestTokenRestriction.restriction_type ||
          skill.globalProjectGuestTokenRestriction.botRestriction_type)
      )
        this.setState({
          globalGuestTokenRestriction: {
            ...skill.globalProjectGuestTokenRestriction,
          },
        });
    } else {
      if (
        skill &&
        skill.globalGuestTokenRestriction &&
        skill.globalGuestTokenRestriction.restriction_type &&
        skill.globalGuestTokenRestriction.botRestriction_type
      )
        this.setState({
          globalGuestTokenRestriction: { ...skill.globalGuestTokenRestriction },
        });
    }
    this.setState({ editMode: false, botEditMode: false });
  };

  render() {
    const { isWorkspaceAdmin, currentSkill, botUsers } = this.props;
    const {
      editMode,
      botEditMode,
      actionDisabled,
      globalGuestTokenRestriction,
    } = this.state;

    // let children = members.map((mem) => {
    //   let disabled = false;
    //   if (mem && mem.user_id && mem.user_id._id) {
    //     const user = mem.user_id;
    //     return (
    //       <Option
    //         key={user._id}
    //         value={user._id}
    //         name={user.displayName || user.name || ''}
    //         disabled={disabled}
    //       >
    //         {user.displayName || user.name || ''}
    //       </Option>
    //     );
    //   }
    // });
    let bChildren = botUsers.map((bot) => {
      return (
        <Option key={bot.id} value={bot.id} name={bot.name}>
          {bot.name}
        </Option>
      );
    });
    return (
      // <Card
      //   title='Global guest user restriction'
      //   extra={
      //     <Switch
      //       checked={!globalGuestTokenRestriction.restrictionDisabled}
      //       onChange={(checked, e) => {
      //         e.stopPropagation();
      //         this.handleSwitch(checked);
      //       }}
      //       disabled={!isWorkspaceAdmin}
      //     />
      //   }
      // >
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 8,
          }}
        >
          <div>
            <div style={{ marginBottom: 8, width: '50vw' }}>
              <Text>
                <strong>Guest user restrictions: </strong>
              </Text>
              <Text type='secondary'>
                Allow or block guest access to specific users
              </Text>
            </div>
            {!globalGuestTokenRestriction.restrictionDisabled && (
              <div>
                <Radio.Group
                  disabled={!editMode}
                  value={globalGuestTokenRestriction.restriction_type}
                  onChange={(e) =>
                    this.handleChange({ type: 'radio', value: e.target.value })
                  }
                >
                  <Space>
                    <Radio value={'block'}>
                      <Text type='secondary'>Block users</Text>
                    </Radio>
                    <Radio value={'allow'}>
                      <Text type='secondary'>Allow users</Text>
                    </Radio>
                  </Space>
                </Radio.Group>
                <br />
                <br />
                <Text type='secondary' strong>
                  Choose users
                </Text>{' '}
                <br />
                <MemberSelect
                  style={{
                    width: '100%',
                    marginBottom: 16,
                  }}
                  mode='multiple'
                  showArrow
                  showSearch
                  autoClearSearchValue
                  placeholder='Select Users'
                  onChange={(value, option) =>
                    this.handleChange({ type: 'select', value, option })
                  }
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={globalGuestTokenRestriction.selectedUsers.map((u) =>
                    u && u.user_id ? u.user_id : u
                  )}
                  defaultUsers={globalGuestTokenRestriction.selectedUsers}
                  disabled={!editMode}
                  allowClear
                />
                {/* {children}
                </Select> */}
                <br />
                <br />
                {isWorkspaceAdmin && (
                  <>
                    {editMode ? (
                      <>
                        <Button
                          type='primary'
                          disabled={
                            globalGuestTokenRestriction &&
                            globalGuestTokenRestriction.selectedUsers &&
                            globalGuestTokenRestriction.selectedUsers.length <=
                              0
                          }
                          onClick={() => this.handleSave()}
                          style={{ width: 100 }}
                          loading={this.state.saveLoading}
                        >
                          Save
                        </Button>
                        <Button
                          style={{ width: 100, marginLeft: 16 }}
                          onClick={() => this.handleCancel()}
                        >
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          style={{ width: 100 }}
                          onClick={() => this.setState({ editMode: true })}
                        >
                          Edit
                        </Button>
                        {globalGuestTokenRestriction &&
                          globalGuestTokenRestriction.selectedUsers &&
                          globalGuestTokenRestriction.selectedUsers.length >
                            0 && (
                            <Popconfirm
                              title='Are you sure you want to delete Guest users restriction?'
                              onConfirm={() => this.handleDelete()}
                              okText='Delete'
                              cancelText='No'
                              placement='top'
                            >
                              <Button
                                style={{ width: 100, marginLeft: 16 }}
                                danger
                              >
                                Delete
                              </Button>
                            </Popconfirm>
                          )}
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>

          <div>
            <Switch
              checked={
                !(
                  globalGuestTokenRestriction &&
                  globalGuestTokenRestriction.restrictionDisabled
                )
              }
              onChange={(checked, e) => {
                e.stopPropagation();
                this.handleSwitch(checked);
              }}
              disabled={!isWorkspaceAdmin}
            />
          </div>
        </div>
        {!this.props.forChannelGuestTokenRestriction && (
          <>
            <Divider />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: 8,
              }}
            >
              <div>
                <div style={{ marginBottom: 8, width: '50vw' }}>
                  <Text>
                    <strong>Guest bots restrictions: </strong>
                  </Text>
                  <Text type='secondary'>
                    Allow or block guest access to specific bots
                  </Text>
                </div>
                {!globalGuestTokenRestriction.botRestrictionDisabled && (
                  <div>
                    <Radio.Group
                      disabled={!botEditMode}
                      value={
                        globalGuestTokenRestriction.botRestriction_type
                          ? globalGuestTokenRestriction.botRestriction_type
                          : 'block'
                      }
                      onChange={(e) =>
                        this.handleChange({
                          type: 'bot_radio',
                          value: e.target.value,
                        })
                      }
                    >
                      <Space>
                        <Radio value={'block'}>
                          <Text type='secondary'>Block users</Text>
                        </Radio>
                        <Radio value={'allow'}>
                          <Text type='secondary'>Allow users</Text>
                        </Radio>
                      </Space>
                    </Radio.Group>
                    <br />
                    <br />
                    <Text type='secondary' strong>
                      Choose Bot Users
                    </Text>{' '}
                    <br />
                    <Select
                      style={{
                        width: '100%',
                        marginBottom: 16,
                      }}
                      mode='multiple'
                      showArrow
                      showSearch
                      autoClearSearchValue
                      placeholder='Select Bot Users'
                      onChange={(value, option) =>
                        this.handleChange({ type: 'bot_select', value, option })
                      }
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={globalGuestTokenRestriction.botUsers}
                      disabled={!botEditMode}
                      allowClear
                    >
                      {bChildren}
                    </Select>
                    <br />
                    <br />
                    {isWorkspaceAdmin && (
                      <>
                        {botEditMode ? (
                          <>
                            <Button
                              type='primary'
                              disabled={
                                globalGuestTokenRestriction.botUsers &&
                                globalGuestTokenRestriction.botUsers.length <= 0
                              }
                              onClick={() => this.handleSave()}
                              style={{ width: 100 }}
                              loading={this.state.saveLoading}
                            >
                              Save
                            </Button>
                            <Button
                              style={{ width: 100, marginLeft: 16 }}
                              onClick={() => this.handleCancel()}
                            >
                              Cancel
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              style={{ width: 100 }}
                              onClick={() =>
                                this.setState({ botEditMode: true })
                              }
                            >
                              Edit
                            </Button>
                            {currentSkill &&
                              globalGuestTokenRestriction &&
                              globalGuestTokenRestriction.botUsers &&
                              globalGuestTokenRestriction.botUsers.length >
                                0 && (
                                <Popconfirm
                                  title='Are you sure you want to delete Guest bots restrictions?'
                                  onConfirm={() => this.handleDelete('bot')}
                                  okText='Delete'
                                  cancelText='No'
                                  placement='top'
                                >
                                  <Button
                                    style={{ width: 100, marginLeft: 16 }}
                                    danger
                                  >
                                    Delete
                                  </Button>
                                </Popconfirm>
                              )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>

              <div>
                <Switch
                  checked={!globalGuestTokenRestriction.botRestrictionDisabled}
                  onChange={(checked, e) => {
                    e.stopPropagation();
                    this.handleSwitch(checked, true);
                  }}
                  disabled={!isWorkspaceAdmin}
                />
              </div>
            </div>
          </>
        )}
      </>

      // </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentSkill: state.skills.currentSkill,
    isWorkspaceAdmin: state.common_reducer.isAdmin,

    botUsers: state.skills.botUsers,
  };
};

export default withRouter(
  connect(mapStateToProps, { updateSkill, channelAdminConfig, getBotUsers })(
    GlobalGuestTokenRestriction
  )
);
